<div class="mainWraps">
    <div class="bgImageWrap">
        <img src="../../../assets/images/patch/technologiesBg.png">
    </div>
    <div class="bgMobileImageWrap">
        <img src="../../../assets/images/TechnologiesMobile.png">
    </div>

    <div class="overLay">
        <div class="textWraps">
            <div class="titleWraps">
                Technologies we cover
            </div>
            <div class="subTitleWrap">
                Product development done right, with breakthrough technologies and Agile processes.
            </div>
           
        </div>
    </div>
</div>


<div class="service-provider">
    <div class="mainWrap">
        <div class="headerSection">
            <div class="descWrap">
                From building a marketplace to serving millions of users to handling a live stream of 50K concurrent users, we solve complex problems using cutting edge technologies.
            </div>
            <div class="titleWrap">
                Our Technology Stack
            </div>
        </div>
        <div class="bodySection">


         <div class="rowWrap" *ngFor = "let i of services">
                <div class="card">
                   
                    <div class="textWrap">
                        <div class="titleRowWrap">
                           {{i.title}}
                        </div>
                        <div class="descRowWrap">
                           {{i.subTitle}}
                        </div>
                    </div>
                    <div class="offeringWrap">
                        <div class="forFull">
                        <div class="headingOffers">
                            Our Offerings
                        </div>
                        <div class="languagesWraps">
                            <div class="langWrap" *ngFor="let o of i.offers">
                                {{o}}
                            </div>
                        </div>
                    </div>

                    </div>
                    <div class="imagesWrapOffers">
                        <div class="imgWrap" *ngFor="let o of i.images">
                           <img src="{{o}}">
                        </div>
                    </div>
                </div>
            </div> 


        </div>
    </div>
</div>